import { Button, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { ROUTES } from '~/constants/routes';

import styles from './styles.module.scss';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = useCallback(() => {
    navigate(ROUTES.HOME);
  }, [navigate]);

  return (
    <div className={styles.container}>
      <Typography
        color="var(--blue-1-color-5)"
        fontSize="600px"
        fontWeight="900"
        left="50%"
        lineHeight="731px"
        position="absolute"
        sx={{ transform: 'translateX(-50%)' }}
        variant="h1"
      >
        404
      </Typography>
      <div className={styles.container__content}>
        <Typography
          color="var(--text-5-color)"
          fontSize="128px"
          fontWeight="700"
          lineHeight="150px"
          mb="30px"
          variant="h1"
        >
          Ooops!
        </Typography>
        <Typography color="var(--text-5-color)" mb="17px" variant="h5">
          404 - PAGE NOT FOUND
        </Typography>
        <Typography color="var(--gray-14-color)" lineHeight="20px" mb="20px" variant="subtitle1">
          The requested resource could not be found.
        </Typography>
        <Button sx={{ width: '336px' }} onClick={handleGoBack}>
          Go Back
        </Button>
      </div>
    </div>
  );
};
